import angular from 'angular';
let inject = ['$scope', '$uibModalInstance', '$state','ProductDetailService','product','userId'];

class ModalCommentsController {
    constructor ($scope,$uibModalInstance, $state,ProductDetailService,product,userId) {
        this.$scope = $scope;
        this.$uibModalInstance = $uibModalInstance;
        this.$state = $state;
        this.ProductDetailService = ProductDetailService;
        this.commentDataForm = {};
        this.productDetail = angular.copy(product);
        this.userId = userId;

        this.addTitle = false;
    }

    $onInit(){
      
    }

    submitComment(submitForm) {

    if(!this.saving){
      if (submitForm.$valid && this.commentDataForm.rating > 0) {
        this.saving = true

        let params = {
          item_id: this.productDetail.id,
          puntaje: this.commentDataForm.rating,
          titulo: this.commentDataForm.title,
          comentario: this.commentDataForm.comment,
          user_id: this.userId
        };

        this.ProductDetailService.setProductComments(params).then(value => {

          if (!value.error) {
            this.commentDataForm.comment = '';
            submitForm.comment.$pristine = true;
            this.commentDataForm.rating = 0;
          }

          this.$uibModalInstance.close(value);

        }).catch(err => {
          console.log(err);
        });

      } else {
        angular.forEach(submitForm.$error.required, function (field) {
          field.$setDirty();
        });

        if (this.commentDataForm.rating === 0 || !this.ratingSelected) {
          this.ratingSelected = true;
        }
      }
    }
    }

    cancel() {
        this.$uibModalInstance.dismiss('cancel');
    }


}

ModalCommentsController.$inject = inject;

export default ModalCommentsController ;



// WEBPACK FOOTER //
// ./www/components/catalog/modal-comments/modal-comments.controller.js